import React from 'react';
import {Switch, Redirect, Route} from 'react-router-dom';
import {TitleAdmin} from 'admin/components';
import {AdminBoard} from 'admin/section';
const COLLECTION = 'recruit';
const adminLnb = [
  {
    name: '가꿈지기 채용',
    path: "/admin/recruit/staff",
    doc: "staff"
  },
  {
    name: '직원 채용',
    path: "/admin/recruit/manager",
    doc: 'manager'
  }
]

const AdminRecruit = () => {

  
  return (
    <div className="AdminRecruit">
      <div className="admin-header">
        <div className="con admin">
          <TitleAdmin title = "Recruit" lnb  = {adminLnb} />
        </div>
      </div>

      <div className="admin-contents">
        <div className="con admin">

          <Switch>
            <Redirect exact from="/admin/recruit" to={adminLnb[0].path} />
            {adminLnb.map(el=> {
              return <Route path={el.path} render ={ () => (<AdminBoard name = {el.name} collection = {COLLECTION} doc = {el.doc}/>)} key = {el.name}/>
            })}
          </Switch>

        </div>
      </div>


    </div>
  );
}

export default AdminRecruit;